<template>
	<popupLayout :cssValue="'border-top: 5px solid #e50012; border-radius: 5px 0 5px 5px; padding: 33px 33px 15px;'">
		<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
		<div class="bootbox-body">
			<div class="form-group mb-lg">
				<label>名稱</label>
				<div class="input-group input-group-icon">
					<input name="account" type="text" class="form-control input-lg" v-model="account" v-validate="'required'" :disabled="stage > 1"/>
					<span class="input-group-addon">
						<span class="icon icon-lg">
							<i class="fa fa-user"></i>
						</span>
					</span>
				</div>
				<span class="text-danger" v-show="errors.has('account')">{{ errors.first('account') }}</span>
			</div>
			<div class="form-group mb-lg">
				<div class="clearfix">
					<label class="pull-left">密碼</label>
					<!-- <a href="pages-recover-password.html" class="pull-right">忘記密碼?</a> -->
				</div>
				<div class="input-group input-group-icon">
					<input name="passwd" type="password" class="form-control input-lg" v-model="passwd" v-validate="'required'" v-on:keydown.13="loginNext()" :disabled="stage > 1"/>
					<span class="input-group-addon">
						<span class="icon icon-lg">
							<i class="fa fa-lock"></i>
						</span>
					</span>
				</div>
				<span class="text-danger" v-show="errors.has('passwd')">{{ errors.first('passwd') }}</span>
			</div>
			<div class="form-group mb-lg" v-show="stage == 2">
				<label>單位</label>
				<div class="input-group input-group-icon">
					<select name="deptCode" v-model="deptCode" class="form-control input-lg" v-validate="stage == 2 ? 'required':''">
						<option value="">--請選擇--</option>
						<option v-for="(item, key) in deptList" :key="key" :value="item.unitId">{{item.unitStr}}</option>
					</select>
					<span class="text-danger" v-show="errors.has('deptCode')">{{ errors.first('deptCode') }}</span>
				</div>
			</div>
			<div class="row form-group" v-if="stage == 1">
				<div class="col-md-8">
					<label for="isRemember">
						<input id="isRemember" name="isRemember" type="checkbox" v-model="isRemember" />記住我
					</label>
				</div>
				<div class="col-md-4 text-right">
					<button type="submit" class="btn btn-primary hidden-xs" @click="loginNext()">下一步</button>
					<button type="submit" class="btn btn-primary btn-block btn-lg visible-xs mt-lg" @click="loginNext()">下一步</button>
				</div>
			</div>
			<div class="row form-group" v-if="stage == 2">
				<div class="col-md-offset-8 col-md-4 text-right">
					<button type="submit" class="btn btn-primary hidden-xs" @click="loginAction()">登入</button>
					<button type="submit" class="btn btn-primary btn-block btn-lg visible-xs mt-lg" @click="loginAction()">登入</button>
				</div>
			</div>
			<hr>
			<p class="text-center">學生生活輔導系統<a href="javascript:;">資安政策說明</a></p>
		</div>
	</popupLayout>
</template>
<script>
import popupLayout from './popupLayout';
export default {
	components:{
		popupLayout
	},
	data(){
		return{
			stage:1,
			account:"",
			passwd:"",
			isRemember:false,
			deptList:[],
			deptCode:"",
			accountData:{}
		}
	},
	methods:{
		loginNext(){
			let _this = this;
			let param = { account: this.account, passwd:this.passwd, isRemember:this.isRemember};
			this.$validator.validateAll().then(result =>{
				if(result){
					const api = "/api/Index/loginCheck";
					this.$axios.post(api, JSON.stringify(param)).then(resp => {
						_this.$parent.clearStore();
						if (resp.data.status == "success"){
							if(param.isRemember){
								param["deadline"] = new Date();
								_this.$parent.setStore("pageData", JSON.stringify(param));
							}else{
								_this.$parent.removeStore("pageData");
							}
							_this.accountData = resp.data.data.sessionData;
							if(_this.accountData.accountType == "TCH"){
								_this.accountData["deptList"] = resp.data.data.unitList;
								_this.deptList = resp.data.data.unitList;
								_this.stage = 2;
							}else{
								_this.$parent.loginComplete(_this.accountData);
							}
							
						}else{
							bootbox.alert(resp.data.msg);
							_this.$parent.loginInit();
						}
					});
				}else{
					bootbox.alert("請確認必填欄位是否有填寫");
				}
			});
		},
		loginAction(){
			let _this = this;
			this.$validator.validateAll().then((result) => {
				if (result) {
					_this.accountData.deptCode = this.deptCode;
					_this.$parent.loginComplete(_this.accountData);
				} else {
					bootbox.alert("請確認必填欄位是否有填寫");
				}
			});
		},
		closePopup() {
			this.$parent.showLoginPopupControl(false);
		}
	},
	created(){
		if(window.localStorage.getItem("pageData") != null){
			const store = JSON.parse(window.localStorage.getItem("pageData"));
			this.account = store.account;
			this.passwd = store.passwd;
			this.isRemember = store.isRemember;
		}
	}
}
</script>
<style scoped>
.checkbox-custom-checked {
	position: absolute;
	display: inline-block;
	font-family: 'FontAwesome';
	content: '\F00C';
	top: 50%;
	left: 4px;
	margin-top: -5px;
	font-size: 11px;
	line-height: 1;
	width: 16px;
	height: 16px;
	color: #333;
}
</style>